import { render, staticRenderFns } from "./PageBreakV1.vue?vue&type=template&id=65f15eb9&scoped=true&"
import script from "./PageBreakV1.vue?vue&type=script&lang=js&"
export * from "./PageBreakV1.vue?vue&type=script&lang=js&"
import style0 from "./PageBreakV1.vue?vue&type=style&index=0&id=65f15eb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f15eb9",
  null
  
)

export default component.exports